<template>
    <div class="clock">
        <div class="header-text-clock">
            <div class="date">{{ clockDate }}</div>
            <div class="time">{{ clockTime }}</div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import "moment/locale/ko";

export default {
    data() {
        return {
            serverNow: null,
            localSec: 0,
            clockDate: "",
            clockTime: "",
            clockInterval: null,
        };
    },
    watch: {
        "$store.getters.serverNow"(newV) {
            this.localSec = 0;
            this.serverNow = moment(newV);
        },
    },

    created() {
        this.startClock();
    },
    beforeDestroy() {
        clearInterval(this.clockInterval);
    },
    methods: {
        startClock() {
            this.clockInterval = setInterval(this.changeClock, 1000);
        },
        changeClock() {
            if (!this.serverNow || !moment.isMoment(this.serverNow)) return;

            const now = this.serverNow
                .clone()
                .add(++this.localSec, "seconds")
                .locale("ko");

            this.clockDate = now.format("YYYY-MM-DD (ddd)");
            this.clockTime = now.format("HH:mm:ss");
        },
    },
};
</script>

<style scoped>
.clock {
    height: 100%;
    display: flex;
    align-items: center;
}
.header-text-clock {
    line-height: 1.1;
    background-color: #eceff1;
    color: #455a64;
    border-radius: 8px;
    font-size: 12px;
    box-shadow: inset 0 0 3px #455a6420;
    height: 70%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.date {
    font-size: 10px;
    margin-bottom: 3px;
}
.time {
    color: black;
}
</style>
